"use strict";
import {http} from '../../core'
const RequestService = http.create()

export default {
    // 获取部门树顶级节点
    treeTop: function(params) {
        return RequestService.get('organization/department/tree/top', params)
    },
    // 获取部门树顶级节点
    treeChildren: function(params) {
        return RequestService.get('organization/department/tree/children', params)
    },
    // 获取部门树顶级节点
    treeUser: function(params) {
        return RequestService.get('organization/department/tree/user', params)
    },
    // 新增部门
    departmentAdd: function(params) {
        return RequestService.post('organization/department/add', params)
    },
    // 新增服务组
    groupAdd: function(params) {
        return RequestService.post('organization/group/add', params)
    },
    // 编辑部门
    departmentUpdate: function(params) {
        return RequestService.post('organization/department/update', params)
    },
    // 编辑服务组
    groupUpdate: function(params) {
        return RequestService.post('organization/group/update', params)
    },
    // 删除部门
    departmentDelete: function(params) {
        return RequestService.post('organization/department/delete', params)
    },
    // 服务组删除用户
    userGroupDelete: function(params) {
        return RequestService.post('organization/group/user_group/delete', params)
    },
    // 删除服务组
    groupDelete: function(params) {
        return RequestService.post('organization/group/delete', params)
    },
     // 获取部门用户
    departmentUser: function(params) {
        return RequestService.get('organization/user/department_user', params)
    },
    // 获取部门用户
    groupUser: function(params) {
        return RequestService.post('organization/user/group_user', params)
    },
     // 用户列表
    userList: function(params) {
        return RequestService.get('organization/user/list', params)
    },
    // 批量更新用户部门
    updateDepartment: function(params) {
        return RequestService.post('organization/user/update_department', params)
    },
    // 服务组添加用户
    updateGroup: function updateGroup(params) {
        return RequestService.post('organization/group/user_group/add', params)
    }
}
